/**
 * WEB: v2 is live only for an allowlisted terminal, so "is v2 the model on this device?" is the
 * allowlist question, asked of the store rather than of a component's props — the callers are
 * plain functions outside React (`saleHelpers`, `homeLayout`'s poll, `useCancellationFlow`).
 *
 * The phone-width layout is v1 whatever the allowlist says (`Containers/MyOrder` tests
 * `isMobileView()` before the gate), so it is v1's model there too — otherwise those
 * callers route their refresh to v2 and v1's phone lists stop refreshing.
 */
import store from "../../redux-store";
import { isMobileView } from "../../helpers/commonHelpers";
import { ordersV2Enabled } from "./shared";

export * from "./shared";

/** True when THIS terminal's my-orders screen is v2 — i.e. when v2's model is the live one. */
export const ordersV2Active = () =>
  !isMobileView() && ordersV2Enabled(store.getState()?.businessStore?.businessData);
